// extracted by mini-css-extract-plugin
export default {"ganttContainer":"view-dependencies_ganttContainer__yWHcb"};